module.exports = __webpack_public_path__ + "img/icon-info-circle.9150c255.svg";